import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import { UpdateUseCasePayload, UseCase } from '@app/domains/useCases/types/useCases.types'

export const fetchUseCases = async (signal?: AbortSignal): Promise<UseCase[]> => {
  const { data } = await apiClient.get<UseCase[]>(Endpoint.getUseCases, { signal })
  return data
}

export const updateUseCase = async (
  slug: string,
  payload: UpdateUseCasePayload,
): Promise<UseCase> => {
  const { data } = await apiClient.put<UseCase>(`${Endpoint.getUseCases}/${slug}`, payload)
  return data
}

export const enableUseCase = async (slug: string, enabled: boolean): Promise<UseCase> => {
  const { data } = await apiClient.put<UseCase>(`${Endpoint.getUseCases}/${slug}`, {
    enabled,
  })
  return data
}
